import { createSlice } from "@reduxjs/toolkit";
import {
  AgFamilyMemberModalFieldsJSON,
  AgMemberEditModalFieldsJSON,
  AgMemberModalFieldsJSON,
} from "../../pages/AGMember/Json/AgMemberFieldsJson";
// import { agMemberTabs } from "../../pages/AGMember/Json/AgMemberJson";
import dateFormat from "dateformat";
import {
  AGFM_FROM_DATE,
  AGFM_TO_DATE,
  AGM_FROM_DATE,
  AGM_TO_DATE,
} from "../../Utils/FilterDateKeys";
import { agMemberTabs } from "../../pages/AGMember/Json/AgMemberJson";

const enterpriseid = localStorage.getItem("enterpriseid");
const userid = localStorage.getItem("userId");

const initialState = {
  agMemberData: [],
  agMemberFieldJson: AgMemberModalFieldsJSON,
  agMemberEditFieldJson: AgMemberEditModalFieldsJSON,
  ProfileFieldsJSON: {},
  ProfileLayoutJSON: [],
  profileJson: {},
  editDetailShow: false,
  confirmationShow: false,
  currentModal: null,
  editCredential: {},
  selectedAgMember: {
    tabs: agMemberTabs,
    activeTab: "details",
    detailsData: {},
    familyData: [],
    agFamilyMemberFieldJson: AgFamilyMemberModalFieldsJSON,
    agFamilyEdit: {
      id: null,
      code: null,
    },
  },
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // user_id: userid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [AGM_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [AGM_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
  agfmSorting: {
    column: "code",
    order: "DESC",
  },
  agfmFilter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // user_id: userid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [AGFM_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [AGFM_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
  mode: "VIEW"
};

const agMemberSlice = createSlice({
  name: "agMember",
  initialState,
  reducers: {
    setAgMemberData(state, action) {
      state.agMemberData = action.payload;
    },
    setAgMemberFieldJson(state, action) {
      state.agMemberFieldJson = action.payload;
    },
    setAgMemberEditFieldJson(state, action) {
      state.agMemberEditFieldJson = action.payload;
    },
    changeActiveTab: (state, action) => {
      state.selectedAgMember.activeTab = action.payload;
    },
    setFamilyData(state, action) {
      state.selectedAgMember.familyData = action.payload;
    },
    setAgFamilyMemberFieldJson(state, action) {
      state.selectedAgMember.agFamilyMemberFieldJson = action.payload;
    },
    setAgFamilyEditID(state, action) {
      state.selectedAgMember.agFamilyEdit.id = action.payload;
    },
    setAgMemberIdData: (state, action) => {
      state.selectedAgMember.detailsData = action.payload;
    },
    setAgMemberFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    setAgMemberFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
            // user_id: userid,
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[AGM_FROM_DATE];
          delete state.filter.form[AGM_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setAgMemberFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setAgMemberSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setAgfmFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    setAgfmFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.agfmFilter.form = {
            // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
            // user_id: userid,
          };
          state.agfmFilter.isFormChanged = true;
          state.agfmFilter.formCopy = state.agfmFilter.form;
          break;
        case "disableApplySpam":
          state.agfmFilter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.agfmFilter.form[AGM_FROM_DATE];
          delete state.agfmFilter.form[AGM_TO_DATE];
          state.agfmFilter.isFormChanged = true;
          break;
        default:
          state.agfmFilter.form = {
            ...state.agfmFilter.form,
            [action.payload.name]: action.payload.value,
          };
          state.agfmFilter.isFormChanged = true;
      }
    },
    setAgfmFilterFormCopy(state, action) {
      state.agfmFilter.formCopy = action.payload;
    },
    setAgfmSorting(state, action) {
      state.agfmSorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setProfileFieldsJSON: (state, action) => {
      state.ProfileFieldsJSON = action.payload;
    },
    setProfileLayoutJSON: (state, action) => {
      state.ProfileLayoutJSON = action.payload;
    },
    setProfileJson: (state, action) => {
      state.profileJson = action.payload;
    },
    editDetailModal(state, action) {
      state.editDetailShow = action.payload;
    },
    confirmationModal(state, action) {
      state.confirmationShow = action.payload;
    },
    showModal: (state, action) => {
      state.currentModal = action.payload; // This should update currentModal
    },
    setEditCredential(state, action) {
      state.editCredential = action.payload;
    },
    setMode(state, action) {
      state.mode = action.payload;
    },
  },
});

export const {
  setAgMemberData,
  setAgMemberFieldJson,
  setAgMemberEditFieldJson,
  changeActiveTab,
  setFamilyData,
  setAgFamilyMemberFieldJson,
  setAgFamilyEditID,
  setAgMemberIdData,
  setAgMemberFilterApi,
  setAgMemberFilterForm,
  setAgMemberFilterFormCopy,
  setAgMemberSorting,
  setAgfmFilterApi,
  setAgfmFilterForm,
  setAgfmFilterFormCopy,
  setAgfmSorting,
  setProfileFieldsJSON,
  setProfileLayoutJSON,
  setProfileJson,
  editDetailModal,
  confirmationModal,
  showModal,
  setEditCredential,
  setMode
} = agMemberSlice.actions;

export default agMemberSlice.reducer;
